import { createStore } from "zustand/vanilla";

export type ToastTone = "neutral" | "success" | "error";

export interface ToastAction {
  label: string;
  onClick: () => void;
}

export interface ToastItem {
  id: number;
  tone: ToastTone;
  title: string;
  description?: string;
  action?: ToastAction;
}

interface ToastState {
  toasts: ToastItem[];
}

export const toastStore = createStore<ToastState>(() => ({ toasts: [] }));

let nextId = 1;

/** Five on screen at most: a burst of failures should not wallpaper the page. */
const MAX_VISIBLE = 5;

function show(item: Omit<ToastItem, "id">): number {
  const id = nextId++;
  const toasts = [...toastStore.getState().toasts, { ...item, id }].slice(-MAX_VISIBLE);
  toastStore.setState({ toasts });
  return id;
}

export function dismissToast(id: number): void {
  toastStore.setState({ toasts: toastStore.getState().toasts.filter((t) => t.id !== id) });
}

/**
 * Callable from anywhere, including outside React (the sync engine reports a
 * rejected change through this).
 */
export const toast = {
  show,
  success: (title: string, extra?: Omit<ToastItem, "id" | "tone" | "title">) =>
    show({ tone: "success", title, ...extra }),
  error: (title: string, extra?: Omit<ToastItem, "id" | "tone" | "title">) =>
    show({ tone: "error", title, ...extra }),
  neutral: (title: string, extra?: Omit<ToastItem, "id" | "tone" | "title">) =>
    show({ tone: "neutral", title, ...extra }),
};
